"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var ReactDOM = require("react-dom");

var semantic_ui_react_1 = require("semantic-ui-react");

var ComponentCard =
/** @class */
function (_super) {
  __extends(ComponentCard, _super);

  function ComponentCard(props) {
    var _this = _super.call(this, props) || this;

    _this.cardRef = null;

    _this.renderTopMenu = function (height) {
      return React.createElement(semantic_ui_react_1.Menu, {
        secondary: true,
        style: {
          margin: 0,
          height: height
        }
      }, React.createElement(semantic_ui_react_1.Menu.Item, {
        position: 'left',
        fitted: 'horizontally',
        style: {
          margin: 0
        }
      }, React.createElement("img", {
        alt: 'component icon',
        src: _this.props.iconSrc,
        style: {
          height: '32px',
          padding: '2px',
          width: '32px'
        }
      }), _this.props.componentName), React.createElement(semantic_ui_react_1.Menu.Item, {
        position: 'right',
        fitted: 'horizontally',
        style: {
          margin: 0
        }
      }, React.createElement(semantic_ui_react_1.Icon, {
        name: _this.state.isFullPage ? 'compress' : 'expand arrows alternate',
        onClick: _this.onFullPageToggle
      }), _this.props.showSettings && React.createElement(semantic_ui_react_1.Icon, {
        name: 'settings'
      })));
    };

    _this.onFullPageToggle = function () {
      _this.setState({
        isFullPage: !_this.state.isFullPage
      });
    };

    _this.state = {
      framedStyle: {
        transformOrigin: 'top left'
      },
      isFullPage: props.isFullPage
    };
    return _this;
  }

  ComponentCard.prototype.componentDidMount = function () {
    var _this = this;

    if (this.props.isFramedComponent) {
      window.onresize = function () {
        if (_this.props.isFramedComponent) {
          _this.resizeFramedComponent();
        }
      };

      this.resizeFramedComponent();
    }
  };

  ComponentCard.prototype.componentDidUpdate = function (prevProps, prevState) {
    var isFullPage = this.state.isFullPage;

    if (isFullPage !== prevState.isFullPage) {
      this.resizeFramedComponent();
    }
  };

  ComponentCard.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        children = _a.children,
        headerHeight = _a.headerHeight,
        height = _a.height,
        isFramedComponent = _a.isFramedComponent,
        width = _a.width;
    var _b = this.state,
        isFullPage = _b.isFullPage,
        framedStyle = _b.framedStyle;
    var expandedStyle = {
      bottom: 0,
      height: 'calc(100vmin)',
      left: 0,
      padding: '5px',
      position: 'fixed',
      right: 0,
      width: 'calc(100vmin)',
      zIndex: 10000
    };

    var cardStyle = __assign({
      maxWidth: 'unset',
      padding: '0 0 5px 5px'
    }, isFullPage ? __assign({}, expandedStyle) : {
      height: height,
      width: width
    });

    var dimmedBackground = document.getElementById('chell-dimmed-background');

    if (isFullPage && dimmedBackground) {
      dimmedBackground.style.display = 'block';
    } else if (dimmedBackground) {
      dimmedBackground.style.display = 'none';
    }

    return React.createElement(semantic_ui_react_1.Card, {
      centered: true,
      className: 'chell-component-card',
      ref: function ref(_ref) {
        return _this.cardRef = _ref;
      },
      style: cardStyle
    }, this.renderTopMenu(headerHeight), isFramedComponent ? React.createElement("div", {
      style: framedStyle
    }, children) : children);
  };

  ComponentCard.prototype.resizeFramedComponent = function () {
    var _a = this.props,
        frameHeight = _a.frameHeight,
        frameWidth = _a.frameWidth,
        headerHeight = _a.headerHeight;
    var _b = this.state,
        framedStyle = _b.framedStyle,
        isFullPage = _b.isFullPage;

    if (this.cardRef) {
      var iFrameNodeRef = ReactDOM.findDOMNode(this.cardRef);
      var iFrameNodeStyle = iFrameNodeRef ? window.getComputedStyle(iFrameNodeRef) : null;

      if (iFrameNodeStyle && iFrameNodeStyle.width && iFrameNodeStyle.height) {
        document.body.style.overflowY = isFullPage ? 'hidden' : 'auto';
        var refHeight = parseInt(iFrameNodeStyle.height, 10) - 18;
        var refWidth = parseInt(iFrameNodeStyle.width, 10) - 10;
        this.setState({
          framedStyle: __assign({}, framedStyle, {
            transform: "scale(calc(" + refWidth + "/" + frameWidth + "),calc((" + refHeight + " - " + headerHeight + ")/" + frameHeight + "))"
          })
        });
      }
    }
  };

  ComponentCard.defaultProps = {
    frameHeight: 0,
    frameWidth: 0,
    headerHeight: 32,
    height: '525px',
    iconSrc: 'assets/icons/spring-icon.png',
    isFramedComponent: false,
    isFullPage: false,
    padding: 0,
    showSettings: false,
    width: '525px'
  };
  return ComponentCard;
}(React.Component);

exports.ComponentCard = ComponentCard;